import styled from 'styled-components';

const Icon = styled.img`
  width: 84px;
  height: 84px;
  border-radius: 15px;
`;

export { Icon };
